<template>
	<v-dialog v-model="activeDialog" max-width="var(--app-size-dialog-sm)" persistent>
		<v-card>
			<v-card-title class="headline text-center">{{ title }}</v-card-title>
			<v-card-text class="text-center">
				<v-progress-circular indeterminate color="primary" :size="size" width="5">
					<MutualLogo class="wait-icon" />
				</v-progress-circular>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import MutualLogo from './MutualLogo.vue'

const props = withDefaults(defineProps<{
	isActive?: boolean
	title?: string
	size?: number
}>(), {
	isActive: false,
	title: 'Please wait...',
	size: 50,
})

// Mirrors the prop into local state rather than binding v-model straight to it,
// because v-dialog writes back on dismiss and the prop is not writable.
const activeDialog = ref(props.isActive)

watch(() => props.isActive, (newVal) => {
	activeDialog.value = newVal
})
</script>
